import styled from 'styled-components';

export const FilterContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  gap: 12px;
  align-items: center;
`;

export const FilterCard = styled.div`
  display: flex;
  align-items: center;
`;

export const FilterTitle = styled.div`
  font-size: 18px;
  font-weight: 500;
  margin-right: 16px;
  color: #000;
`;

export const FilterSeparator = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: rgb(0 0 0 / 60%);
`;
